// src/utils/normalizeItemName.js

const ITEM_ALIASES = {
    "gbc": "gift box mystery capsule",
    "gbcs": "gift box mystery capsule",
    "cap": "gift box mystery capsule",
    "caps": "gift box mystery capsule",
    "bfgbc": "black friday gift box mystery capsule",
    "bfgbcs": "black friday gift box mystery capsule",
    "bf gbc": "black friday gift box mystery capsule",
    "bf gbcs": "black friday gift box mystery capsule",
    "bf gbc/s": "black friday gift box mystery capsule",

    "sss": "styling studio supplies",
    "dsss": "deluxe styling studio supplies",
    "d/sss": "deluxe styling studio supplies",
    "deluxe sss": "deluxe styling studio supplies",
    "prismatic brush": "styling studio prismatic brush",
    "prismatic brushes": "styling studio prismatic brush",
    "prisma brush": "styling studio prismatic brush",
    "prisma brushes": "styling studio prismatic brush",
    "prism brush": "styling studio prismatic brush",
    "prism brushes": "styling studio prismatic brush",
    "deluxe prismatic brush": "styling studio deluxe prismatic brush",
    "deluxe prismatic brushes": "styling studio deluxe prismatic brush",
    "deluxe prisma brush": "styling studio deluxe prismatic brush",
    "deluxe prisma brushes": "styling studio deluxe prismatic brush",
    "deluxe prism brush": "styling studio deluxe prismatic brush",
    "deluxe prism brushes": "styling studio deluxe prismatic brush",
    "ssrp": "styling studio restyle paint",
    "restyle": "styling studio restyle paint",
    "restyles": "styling studio restyle paint",
    "ss restyle": "styling studio restyle paint",
    "ss restyles": "styling studio restyle paint",
    "restyle paint": "styling studio restyle paint",
    "restyle paints": "styling studio restyle paint",

    "dyepot": "dyeworks hue brew potion",
    "dyepots": "dyeworks hue brew potion",
    "dye potion": "dyeworks hue brew potion",
    "dye potions": "dyeworks hue brew potion",
    "dyeworks potion": "dyeworks hue brew potion",
    "dyeworks potions": "dyeworks hue brew potion",
    "dyework potion": "dyeworks hue brew potion",
    "dyework potions": "dyeworks hue brew potion",

    "quest cookie": "faerie quest fortune cookie",
    "quest cookies": "faerie quest fortune cookie",
    "fqfc": "faerie quest fortune cookie",
    "fqfcs": "faerie quest fortune cookie",
    "fqc": "faerie quest fortune cookie",
    "fqcs": "faerie quest fortune cookie",
    "faerie quest cookie": "faerie quest fortune cookie",
    "faerie quest cookies": "faerie quest fortune cookie",
    "faerie cookies": "faerie quest fortune cookie",
    "faerie cookie": "faerie quest fortune cookie",
    "ffq cookie": "faerie quest fortune cookie",
    "ffq cookies": "faerie quest fortune cookie",
    "ffqs cookie": "faerie quest fortune cookie",
    "ffqs cookies": "faerie quest fortune cookie",

    "lab cookie": "lab ray fortune cookie",
    "lab cookies": "lab ray fortune cookie",
    "lab ray cookie": "lab ray fortune cookie",
    "lab ray cookies": "lab ray fortune cookie",
    "lrc": "lab ray fortune cookie",
    "lrcs": "lab ray fortune cookie",

    "petpet cookie": "petpet lab ray fortune cookie",
    "petpet cookies": "petpet lab ray fortune cookie",
    "petpet lab cookie": "petpet lab ray fortune cookie",
    "petpet lab cookies": "petpet lab ray fortune cookie",
    "petpet lab ray cookie": "petpet lab ray fortune cookie",
    "petpet lab ray cookies": "petpet lab ray fortune cookie",
    "p2 cookie": "petpet lab ray fortune cookie",
    "p2 cookies": "petpet lab ray fortune cookie",

    "archives fortune cookie": "nc archives fortune cookie",
    "archives fortune cookies": "nc archives fortune cookie",
    "archives cookie": "nc archives fortune cookie",
    "archives cookies": "nc archives fortune cookie",
    "archive fortune cookie": "nc archives fortune cookie",
    "archive fortune cookies": "nc archives fortune cookie",
    "archive cookie": "nc archives fortune cookie",
    "archive cookies": "nc archives fortune cookie",
    "nc archive cookie": "nc archives fortune cookie",
    "nc archive cookies": "nc archives fortune cookie",

    "nc upcycle cookie": "nc upcycle fortune cookie",
    "nc upcycle cookies": "nc upcycle fortune cookie",
    "upcycle cookie": "nc upcycle fortune cookie",
    "upcycle cookies": "nc upcycle fortune cookie",
    "nc upcycle": "nc upcycle fortune cookie",
    "nc upcycles": "nc upcycle fortune cookie",
    "upcycle": "nc upcycle fortune cookie",
    "upcycles": "nc upcycle fortune cookie",
    "upcycle fortune cookie": "nc upcycle fortune cookie",
    "upcycle fortune cookies": "nc upcycle fortune cookie",

    "training cookie": "training fortune cookie",
    "training cookies": "training fortune cookie",
    "deluxe training cookie": "deluxe training fortune cookie",
    "deluxe training cookies": "deluxe training fortune cookie",

    "plot cookie": "plot points fortune cookie",
    "plot cookies": "plot points fortune cookie",
    "plot points cookie": "plot points fortune cookie",
    "plot points cookies": "plot points fortune cookie",
    "plot point cookie": "plot points fortune cookie",
    "plot point cookies": "plot points fortune cookie",

    // "a heros welcome background": "a heroes welcome background",
    // "cherry blossom teapot handheld": "cherry blossom tea pot handheld",
    // "psimouse teapot handheld": "psimouse tea pot handheld",
    // "dyeworks baby blue: baby valentine jumper and shirt": "dyeworks baby blue: baby valentine jumper",
    // "dyeworks baby pink: baby valentine jumper and shirt": "dyeworks baby pink: baby valentine jumper",
    // "dyeworks baby purple: baby valentine jumper and shirt": "dyeworks baby purple: baby valentine jumper",
    // "dyeworks black: 2010 games master challenge nc challenge lulu shirt": "dyeworks black: games master challenge 2010 lulu shirt",
    // "dyeworks orange: 2010 games master challenge nc challenge lulu shirt": "dyeworks orange: games master challenge 2010 lulu shirt",
    // "dyeworks purple: 2010 games master challenge nc challenge lulu shirt": "dyeworks purple: games master challenge 2010 lulu shirt",
    // "dyeworks black: field of flowers foreground": "dyeworks black: field of flowers",
    // "dyeworks blue: field of flowers foreground": "dyeworks blue: field of flowers",
    // "dyeworks yellow: field of flowers foreground": "dyeworks yellow: field of flowers",
    // "dyeworks fuchsia: jars of magic foreground": "dyeworks fuschia: jars of magic foreground",
    // "dyeworks orange & pink: winter lights effect": "dyeworks orange & pink: winter lights effects",
    // "dyeworks red & green: winter lights effect": "dyeworks red & green: winter lights effects",
    // "dyeworks yellow & magenta: winter lights effect": "dyeworks yellow & magenta: winter lights effects",
    // "dyeworks red: radioactive mutant markings": "dyeworks red radioactive mutant markings",
    // "eternal hearts background": "eternal hearts backround",
    // "holiday secret meepit stache plan 1-pack": "holiday secret meepit stach plan 1-pack",
    // "purple flower embroidery dress": "purple flower embroidiery dress",
    // "retired contacts ii mystery capsule 2024 10-bundle": "retired contacts ii mystery capsule 202410-bundle",
    // "snorkle petpet companion and pitchfork handheld": "snorkel petpet companion and pitchfork handheld",
    // "strapping pharaoh fit": "strapping pharoah fit",
    // "vip gold embellished tuxedo": "vip gold embellishedtuxedo",
    // "ye olde fishing vortex new years background": "ye old fishing vortex new years background",
    // "dyeworks magenta: lovely berry blush makeup": "dyeworks magenta: lovely berry blush",
    // "dyeworks soft pink: lovely berry blush makeup": "dyeworks soft pink: lovely berry blush",
    // "dyeworks peach: lovely berry blush makeup": "dyeworks peach: lovely berry blush",

    "body be-gone": "body be-gone!",
    "antenna & horns be-gone": "antenna & horns be-gone!",
    "drippings be-gone": "drippings be-gone!",
    "eyes be-gone": "eyes be-gone!",
    "feet be-gone": "feet be-gone!",
    "glow effects be-gone": "glow effects be-gone!",
    "hind be-gone": "hind be-gone!",
    "hair be-gone": "hair be-gone!",
    "mouth be-gone": "mouth be-gone!",
    "ruff be-gone": "ruff be-gone!",
    "wings be-gone": "wings be-gone!"
}

export function normalizeItemName(name) {
  name = name.trim().replace(/\s*:\s*/g, ': ').replace(/\s{2,}/g, ' ');
  const lower = name.toLowerCase();
  return ITEM_ALIASES[lower] || lower;
}
